import { motion } from "framer-motion";
import { Play, Quotes } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/constants/site";

export const Testimonials = () => (
  <section id="testimonials" className="py-24 md:py-32 bg-linen relative overflow-hidden" data-testid="testimonials-section">
    <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-mint-pale blur-3xl opacity-60" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
      <Reveal>
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-mint">Client stories</p>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-ink max-w-2xl text-balance">
          In their own words
        </h2>
        <p className="mt-5 text-base sm:text-lg text-moss max-w-xl leading-relaxed">
          Real clients, real experiences — from Trivandrum to Toronto. Press play and hear
          what it's like to be looked after by Kris Fin Care.
        </p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 max-w-5xl mx-auto">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name + t.video} delay={i * 0.12}>
            <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="group" data-testid={`testimonial-card-${i}`}>
              <div className="relative rounded-[1.75rem] overflow-hidden shadow-xl shadow-forest/15 bg-forest-deep">
                <video
                  src={t.video}
                  poster={t.poster}
                  controls
                  playsInline
                  preload="none"
                  className="w-full aspect-[9/16] object-cover"
                  data-testid={`testimonial-video-${i}`}
                />
                <div className="absolute top-4 left-4 pointer-events-none">
                  <span className="inline-flex items-center gap-1.5 bg-white/85 backdrop-blur-md text-forest text-xs font-bold px-3 py-1.5 rounded-full">
                    <Play size={12} weight="fill" /> Client story
                  </span>
                </div>
              </div>
              <div className="mt-5 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-mint-pale text-forest flex items-center justify-center shrink-0">
                  <Quotes size={18} weight="fill" />
                </span>
                <div>
                  <p className="font-semibold text-ink">{t.name}</p>
                  <p className="text-sm text-moss">{t.detail}</p>
                </div>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
